import {
  YGETS_ADDRESS_REQUEST,
  YGETS_ADDRESS_REQUEST_SUCCESS,
  ORDER_AGGREGATORS_REQUEST,
  ORDER_AGGREGATORS_REQUEST_SUCCESS,
  ORDER_AGGREGATORS_REQUEST_FAIL,
  ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST,
  ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_SUCCESS,
  ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_FAIL
} from 'constants/action-types';

const initialState = {
  address: {
    prefectureCode: null,
    prefecture: null,
    city: null
  },
  identification: {
    userId: null,
    password: null,
    redirectUrl: null
  },
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case YGETS_ADDRESS_REQUEST:
      return {
        ...state,
        ...initialState.address
      };

    case ORDER_AGGREGATORS_REQUEST:
      return {
        ...state,
        ...initialState.identification,
        ...initialState.error
      };

    case ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST:
      return {
        ...state,
        ...initialState.identification,
        ...initialState.error
      };

    case YGETS_ADDRESS_REQUEST_SUCCESS:
      return {
        ...state,
        address: action.payload.data
      };

    case ORDER_AGGREGATORS_REQUEST_SUCCESS:
      return {
        ...state,
        identification: action.payload.data
      };

    case ORDER_AGGREGATORS_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    case ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_SUCCESS:
      return {
        ...state,
        identification: action.payload.data
      };

    case ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderAggregators/confirmation.js